import { c as _c } from "react/compiler-runtime";
import { Edit03Icon, Laptop01Icon, Save01Icon, Trash02Icon, XCloseIcon } from '@systemeio/icons';
import { CurrencyEnum, PaymentMethodEnum } from '@systemeio/types';
import { DigitalProductSelectField } from 'modules/digital-product/components/digital-product-select-field';
import { DigitalProductSourceEnum } from 'modules/digital-product/enums/digital-product-source-enum';
import { PricePlansSection } from 'modules/digital-product/price-plans/components/price-plans-section';
import { ResourcesSection } from 'modules/digital-product/resources/components/resources-section';
import { DigitalProductChangeInterface, DigitalProductId } from 'modules/digital-product/types/digital-product-interface';
import { useDigitalProductSelector } from 'modules/funnels/funnel/components/step-configuration-tab/digital-product-selector/hooks/use-digital-product-selector';
import { OfferConfigurationCard } from 'modules/funnels/funnel/components/step-configuration-tab/offer-configuration-card';
import { DigitalOfferEditInterface } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/digital-offer-interface';
import React, { useState } from 'react';
import { Button, FormInput } from 'shared/components';
import Confirmation from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useMediaQuery from 'shared/hooks/use-media-query';
interface DigitalProductSelectorCardProps {
  /** Product the offer currently links to, `null` when nothing is attached yet. */
  attachedId: DigitalProductId | null;
  currency: CurrencyEnum;
  /** Product just added in the modal: an existing one, or a new one without an id. */
  draftProduct?: DigitalProductChangeInterface;
  isBump?: boolean;
  onAttach: (data: DigitalOfferEditInterface['digitalProduct']) => Promise<void>;
  onCleared: () => void;
  paymentMethods: PaymentMethodEnum[];
  source: DigitalProductSourceEnum;
}
export function DigitalProductSelectorCard(t0) {
  const $ = _c(64);
  const {
    attachedId,
    currency,
    draftProduct,
    isBump,
    onAttach,
    onCleared,
    paymentMethods,
    source
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    isMobile
  } = useMediaQuery();
  const [isRemoveProductConfirmationOpen, setIsRemoveProductConfirmationOpen] = useState(false);
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.funnel.configuration.offer.edit_product");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const editProductLabel = t1;
  let t2;
  if ($[2] !== attachedId || $[3] !== currency || $[4] !== draftProduct || $[5] !== onAttach || $[6] !== onCleared || $[7] !== source) {
    t2 = {
      attachedId,
      currency,
      draftProduct,
      onAttach,
      onCleared,
      source
    };
    $[2] = attachedId;
    $[3] = currency;
    $[4] = draftProduct;
    $[5] = onAttach;
    $[6] = onCleared;
    $[7] = source;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const {
    cancelEditing,
    changeProduct,
    errors,
    isAttached,
    isDirty,
    isEditing,
    isFetching,
    isLoading,
    isReadyToSave,
    product,
    removeProduct,
    save,
    startEditing
  } = useDigitalProductSelector(t2);
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Laptop01Icon />;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== changeProduct || $[11] !== currency || $[12] !== errors || $[13] !== isAttached || $[14] !== isBump || $[15] !== isEditing || $[16] !== isFetching || $[17] !== isLoading || $[18] !== product || $[19] !== removeProduct || $[20] !== source || $[21] !== t) {
    t4 = isEditing && product ? <FormInput disabled={isFetching} aria-label={t("dashboard.funnel.configuration.offer.digital_product_name")} value={product.name} onChange={e => changeProduct({
      ...product,
      name: e.target.value
    })} error={errors.name} /> : <DigitalProductSelectField disabled={isAttached || isFetching} isPreFetching={isLoading} aria-label={t("dashboard.funnel.configuration.offer.digital_product")} currency={currency} isBump={isBump} source={source} value={product?.id ?? undefined} onChange={changeProduct} onDeleted={removeProduct} />;
    $[10] = changeProduct;
    $[11] = currency;
    $[12] = errors;
    $[13] = isAttached;
    $[14] = isBump;
    $[15] = isEditing;
    $[16] = isFetching;
    $[17] = isLoading;
    $[18] = product;
    $[19] = removeProduct;
    $[20] = source;
    $[21] = t;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== cancelEditing || $[24] !== editProductLabel || $[25] !== isAttached || $[26] !== isEditing || $[27] !== isFetching || $[28] !== isLoading || $[29] !== isMobile || $[30] !== product || $[31] !== removeProduct || $[32] !== startEditing || $[33] !== t) {
    t5 = isEditing ? <Button disabled={isFetching} aria-label={t("global.close")} onClick={cancelEditing} variant="secondary" size="icon-md"><XCloseIcon /></Button> : <div className="flex items-center gap-2">{product && <Button aria-label={editProductLabel} disabled={isFetching} onClick={startEditing} title={editProductLabel} variant="secondary" size={isMobile ? "icon-md" : "md"}><Edit03Icon />{!isMobile && editProductLabel}</Button>}<Button disabled={isLoading || isFetching} aria-label={t("global.delete")} onClick={() => isAttached ? setIsRemoveProductConfirmationOpen(true) : removeProduct()} variant="secondary" size="icon-md"><Trash02Icon /></Button></div>;
    $[23] = cancelEditing;
    $[24] = editProductLabel;
    $[25] = isAttached;
    $[26] = isEditing;
    $[27] = isFetching;
    $[28] = isLoading;
    $[29] = isMobile;
    $[30] = product;
    $[31] = removeProduct;
    $[32] = startEditing;
    $[33] = t;
    $[34] = t5;
  } else {
    t5 = $[34];
  }
  let t6;
  if ($[35] !== changeProduct || $[36] !== currency || $[37] !== errors || $[38] !== isAttached || $[39] !== isBump || $[40] !== isDirty || $[41] !== isEditing || $[42] !== isFetching || $[43] !== isReadyToSave || $[44] !== paymentMethods || $[45] !== product || $[46] !== save || $[47] !== t) {
    t6 = product && <div className="tablet:ml-12 mt-3.5 flex flex-col gap-7"><ResourcesSection errors={errors.resources} readOnly={!isEditing || isFetching} resources={product.resources} onChange={resources => changeProduct({
        ...product,
        resources
      })} /><PricePlansSection currency={currency} errors={errors.pricePlans} maxPricePlans={isBump ? 1 : undefined} paymentMethods={paymentMethods} pricePlans={product.pricePlans} readOnly={!isEditing || isFetching} onChange={pricePlans => changeProduct({
        ...product,
        pricePlans
      })} onPricePlanUpdated={pricePlans_0 => changeProduct({
        ...product,
        pricePlans: pricePlans_0
      })} />{(isEditing || !isAttached) && <Button className="ml-auto" disabled={!isReadyToSave || !isDirty} isLoading={isFetching} onClick={save} type="button" variant="primary" size="sm"><Save01Icon />{t("global.save")}</Button>}</div>;
    $[35] = changeProduct;
    $[36] = currency;
    $[37] = errors;
    $[38] = isAttached;
    $[39] = isBump;
    $[40] = isDirty;
    $[41] = isEditing;
    $[42] = isFetching;
    $[43] = isReadyToSave;
    $[44] = paymentMethods;
    $[45] = product;
    $[46] = save;
    $[47] = t;
    $[48] = t6;
  } else {
    t6 = $[48];
  }
  let t7;
  if ($[49] !== t4 || $[50] !== t5 || $[51] !== t6) {
    t7 = <OfferConfigurationCard icon={t3} content={t4} action={t5}>{t6}</OfferConfigurationCard>;
    $[49] = t4;
    $[50] = t5;
    $[51] = t6;
    $[52] = t7;
  } else {
    t7 = $[52];
  }
  let t8;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsRemoveProductConfirmationOpen(false);
    $[53] = t8;
  } else {
    t8 = $[53];
  }
  const t9 = product?.name;
  let t10;
  if ($[54] !== t || $[55] !== t9) {
    t10 = t("dashboard.digital_product.remove.description", {
      digitalProduct: t9
    });
    $[54] = t;
    $[55] = t9;
    $[56] = t10;
  } else {
    t10 = $[56];
  }
  let t11;
  if ($[57] !== isRemoveProductConfirmationOpen || $[58] !== removeProduct || $[59] !== t10) {
    t11 = <Confirmation status="error" opened={isRemoveProductConfirmationOpen} onClose={t8} onConfirm={removeProduct} confirmationText={t10} />;
    $[57] = isRemoveProductConfirmationOpen;
    $[58] = removeProduct;
    $[59] = t10;
    $[60] = t11;
  } else {
    t11 = $[60];
  }
  let t12;
  if ($[61] !== t11 || $[62] !== t7) {
    t12 = <>{t7}{t11}</>;
    $[61] = t11;
    $[62] = t7;
    $[63] = t12;
  } else {
    t12 = $[63];
  }
  return t12;
}